<template>
    <div class="header">
        <div class="header-top">
            <div class="container">
                <div class="head-top">
                    <div class="logo">
                        <h1>
                            <router-link to="/">{{settingList.site_title1}} <span>{{settingList.site_title2}}</span></router-link>
                        </h1>
                    </div>
                    <div class="top-nav">
                        <span class="menu" @click="showMenu"><img src="static/images/menu.png" alt=""> </span>
                        <ul ref="navMenu">
                            <li :class="[$route.meta.index==0?'active':'']" @click="hideMenu">
                                <router-link to="/">首页</router-link>
                            </li>
                            <li :class="[$route.meta.index==1?'active':'']" @click="hideMenu">
                                <router-link to="/game">游戏</router-link>
                            </li>
                            <li :class="[$route.meta.index==5?'active':'']" @click="hideMenu">
                                <router-link to="/author">作者</router-link>
                            </li>
                            <li :class="[$route.meta.index==2?'active':'']" @click="hideMenu">
                                <router-link to="/blog">博客</router-link>
                            </li>
                            <li :class="[$route.meta.index==3?'active':'']" @click="hideMenu">
                                <router-link to="/event">事件</router-link>
                            </li>
                            <li :class="[$route.meta.index==4?'active':'']" @click="hideMenu">
                                <router-link to="/about">关于</router-link>
                            </li>

                            <!--<li>-->
                                <!--<a href="http://www.gityx.com/" target="_blank">新首页</a>-->
                            <!--</li>-->
                            <li>
                                <a href="http://bbs.gityx.com" target="_blank">论坛</a>
                            </li>
                            <li>
                                <el-form :inline="true" :model="formInline" class="form-search" @submit.native.prevent>
                                    <el-form-item>
                                        <el-input  v-model="formInline.name" ref="search"  :placeholder="tips" tabindex="1" @keyup.enter.native="onSubmit"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" class="btn-search" @click="onSubmit">搜索</el-button>
                                    </el-form-item>
                                </el-form>
                            </li>
                            <div class="clearfix"></div>
                        </ul>
                        <!--script-->
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Header',
  components: {},
  data() {
    return {
      tips: '请输入游戏关键字',
      settingList: [],
      formInline: {
        name: ''
      }
    }
  },
  created() {
    this.getSiteName()
  },
  mounted() {},
  methods: {
    onSubmit() {
      const keyword = this.formInline.name.trim()
      if (keyword === '') {
        this.$notify({
          title: '提示',
          message: '搜索的关键字不能为空',
          type: 'warning',
          position: 'bottom-right',
          duration: 1000
        })
      } else {
        this.$router.push({ path: '/s=' + keyword })
        this.formInline.name = ''
      }
    },
    showMenu() {
      const ul = this.$refs.navMenu
      if (ul.style.display === 'none' || ul.style.display === '') {
        ul.style.display = 'block'
      } else {
        ul.style.display = 'none'
      }
    },
    hideMenu() {
      const ul = this.$refs.navMenu
      if (ul.style.display === 'block') {
        ul.style.display = 'none'
      }
    },
    getSiteName() {
      if (localStorage.getItem('settingList')) {
        this.settingList = JSON.parse(localStorage.getItem('settingList'))[0]
      } else {
        var timeStamp = new Date().getTime()
        this.$http.get('static/data/setting.json' + '?' + timeStamp).then(res => {
        localStorage.setItem('settingList', JSON.stringify(res.data))
          this.settingList = res.data[0]
        },
        res => {
          console.log('error')
        })
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
